var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4 28.6071L56.4 9.60706C57.4 8.60706 57.6 7.20706 56.6 6.20706L51.8 1.40706C50.8 0.407059 48.9 0.207061 47.9 1.20706L28.9 20.2071L9.89998 1.20706C8.89998 0.207061 7.49998 0.00705981 6.49998 1.00706L1.69998 5.80706C0.69998 6.80706 0.49998 8.70706 1.49998 9.70706L20.5 28.7071L1.49998 47.7071C0.49998 48.7071 0.799979 50.7071 1.79998 51.7071L6.29998 56.2071C7.29998 57.2071 8.89998 57.2071 9.89998 56.2071L28.9 37.2071L47.9 56.2071C48.9 57.2071 50.9 56.9071 51.9 55.9071L56.4 51.4071C57.4 50.4071 57.4 48.8071 56.4 47.8071L37.4 28.6071Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.51ff2dc132a6f437c0da81109830a285.svg";
export { ForwardRef as ReactComponent };